export type BlackListReason = "Devamsızlık" | "Başarısızlık";

/** API reason enum: 1 = ABSENCE, 2 = FAILURE */
export const BANNED_REASON_ABSENCE = 1;
export const BANNED_REASON_FAILURE = 2;

export function apiReasonToUi(value: number): BlackListReason {
  return value === BANNED_REASON_FAILURE ? "Başarısızlık" : "Devamsızlık";
}

export function uiReasonToApi(reason: BlackListReason): number {
  return reason === "Başarısızlık" ? BANNED_REASON_FAILURE : BANNED_REASON_ABSENCE;
}

export interface BlackListEntry {
  id: string;
  personnelId: string;
  personnelName: string;
  /** Banlanan kişi adı soyadı (user.firstName + lastName) */
  bannedPersonName?: string;
  /** Banlayan kişi adı soyadı (bannedByUser.firstName + lastName) */
  bannedByPersonName?: string;
  startDate: string;
  endDate: string;
  reason: BlackListReason;
  /** Optional detail/form fields (for drawer and API) */
  tcKimlikNo?: string;
  description?: string;
  /** Eski API: sadece name/size */
  supportingDocuments?: { name: string; size?: string }[];
  /** Detay response: id, originalName, size, downloadUrl (indirme linki) */
  files?: { id: string; originalName: string; size: number; downloadUrl: string }[];
}

export interface BlackListFormValues {
  personnelId: string;
  personnelName: string;
  startDate: string;
  endDate: string;
  reason: BlackListReason;
  description: string;
  /** Dosya seçildiğinde modal içinde yüklendiyse ID'ler burada gelir */
  fileIds?: string[];
  /** Eski akış: submit sırasında yüklenecek dosyalar (File[]) */
  supportingDocuments?: File[];
}

export interface BlackListFilters {
  search?: string;
  reason?: BlackListReason | BlackListReason[];
}

/** GET /api/admin/banned-users - user (banlanan) / bannedByUser (banlayan) nested */
export interface BannedUserRef {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  identityNumber?: string;
  phoneNumber?: string;
}

/** GET /api/admin/banned-users - single item from backend */
export interface BannedUserApiItem {
  id: string;
  userId?: string;
  user?: BannedUserRef;
  bannedByUser?: BannedUserRef;
  personnelId?: string;
  personnelName?: string;
  identityNumber?: string;
  startDate?: string;
  endDate?: string;
  reason: number;
  bannedAt?: string;
  createdAt?: string;
  description?: string;
  supportingDocuments?: { name: string; size?: string }[];
  /** Detay response: id, originalName, size, downloadUrl */
  files?: { id: string; originalName: string; size: number; downloadUrl: string }[];
}

/** GET /api/admin/banned-users - list response */
export interface BannedUserListResponseApi {
  data?: BannedUserApiItem[];
  count?: number;
  total?: number;
}

/** POST /api/admin/banned-users - create body (CreateBannedUserDto) */
export interface CreateBannedUserDto {
  userId: string;
  reason: number;
  startDate: string;
  endDate: string;
  description?: string;
  fileIds?: string[];
}

/** PATCH /api/admin/banned-users/{id} - update body (Swagger) */
export interface UpdateBannedUserDto {
  reason?: number;
  startDate?: string;
  endDate?: string;
  description?: string;
  fileIds?: string[];
}
